export default __webpack_public_path__ + "static/media/notification_black.09cec5d6.svg";